import * as React from 'react';

import {SelectNew} from 'shells/select-new/select-new';
import {TextField} from 'shells/textfield/textfield';

import type {DueDateUnit} from 'nutshell-graphql-types';
import type {StepDueDateInput} from 'nutshell-graphql-types';

import {dueFromArray} from './due-date-constants';
import {DueUnitPicker} from './fields/due-unit-picker';

import styles from './date-time-picker.module.css';

type Props = {
    dueDate: StepDueDateInput;
    onDueDateChange: (arg1: StepDueDateInput) => void;
};

export class DueDateInputs extends React.PureComponent<Props> {
    render() {
        return (
            <div className={styles['date-picker']}>
                <div className={styles['timespan-input']}>
                    <TextField
                        value={String(this.props.dueDate.dueTimespan)}
                        placeholder='0'
                        // @ts-expect-error
                        name='due-timespan'
                        onChange={this.handleDueTimespanChange}
                    />
                </div>
                <div className={styles['selector-container']}>
                    <DueUnitPicker
                        value={this.props.dueDate.dueUnit}
                        onChange={this.handleDueUnitChange}
                        isSingleUnit={this.props.dueDate.dueTimespan === 1}
                    />
                    <SelectNew
                        valueKey='id'
                        labelKey='value'
                        value={dueFromArray.find((val) => val.id === this.props.dueDate.dueFrom)}
                        onChange={this.handleDueFromChange}
                        // @ts-expect-error
                        selectValues={dueFromArray}
                    />
                </div>
            </div>
        );
    }

    handleDueTimespanChange = (newValue: string) => {
        const newDueDate = {
            dueUnit: this.props.dueDate.dueUnit,
            dueFrom: this.props.dueDate.dueFrom,
            dueTimespan: Number(newValue),
        } as const;

        this.props.onDueDateChange(newDueDate);
    };

    handleDueUnitChange = (newValue: {id: DueDateUnit; value: string}) => {
        const newDueDate = {
            dueFrom: this.props.dueDate.dueFrom,
            dueTimespan: this.props.dueDate.dueTimespan,
            dueUnit: newValue.id,
        } as const;

        this.props.onDueDateChange(newDueDate);
    };

    handleDueFromChange = (newValue: {id: number; value: string}) => {
        const newDueDate = {
            dueUnit: this.props.dueDate.dueUnit,
            dueTimespan: this.props.dueDate.dueTimespan,
            dueFrom: Number(newValue.id),
        } as const;

        this.props.onDueDateChange(newDueDate);
    };
}
